import {mainFailureFactorsChartCalculation} from "./common/main-failure-factors-chart-calculation";

const transformData = [
    {
        name: 'Family & friends',
        value: 'Item 1',
        keyQuestion: 'question21', 
    },
    {
        name: 'Business Angels',
        value: 'Item 2',
        keyQuestion: 'question26',
    },
    {
        name: 'Crowdfunding',
        value: 'Item 3',
        keyQuestion: 'question30',
    },
    {
        name: 'Incubators and Accelerators',
        value: 'Item 4',
        keyQuestion: 'question37',
    },
    {
        name: 'NGO’s loans',
        value: 'Item 5',
        keyQuestion: 'question42',
    },
    {
        name: 'NGO’s grants',
        value: 'Item 6',
        keyQuestion: 'question47',
    },
    {
        name: 'Public subsidies',
        value: 'Item 7',
        keyQuestion: 'question52',
    },
    {
        name: 'Public grants',
        value: 'Item 8',
        keyQuestion: 'question57',
    },
    {
        name: 'Venture capital',
        value: 'Item 9',
        keyQuestion: 'question62',
    },
    {
        name: 'Microfinance',
        value: 'Item 10',
        keyQuestion: 'question67',
    },
    {
        name: 'Financial institutions (banks)',
        value: 'Item 11',
        keyQuestion: 'question72',
    },
    {
        name: 'Other',
        value: 'other',
        keyQuestion: 'question77',
    },
];

/**
 * 
 * @param props 
 */
export const finalMainFailureFactorsChartCalculation = (props: any) => {
    return mainFailureFactorsChartCalculation(props.finalSubmissions, transformData, 'column') as Highcharts.Options;
}